
import DpWpLinkQuery from './DpWpLinkQuery';




export default class DpWpLinkRiver {
	timeToTriggerRiver = 150;
	minRiverAJAXDuration = 200;
	riverBottomThreshold = 5;
	posts = {};

	constructor(element, dpWpLink) {
		if (dpWpLink.config.dpDebugEn) console.log('[dpit] INIT DpWpLinkRiver');
		this.dpWpLink = dpWpLink;
		this.config = dpWpLink.config;
		this.element = element;
		this.ul = element.children('ul');
		this.contentHeight = element.children('#dp_link-selector-height');
		this.waiting = element.find('.river-waiting');
		this.init();
	}


	delayedCallback(func, delay) {
		let timeoutTriggered; let funcTriggered; let funcArgs; let
			funcContext;

		if (!delay) return func;

		setTimeout(() => {
			if (funcTriggered) return func.apply(funcContext, funcArgs);
			// Otherwise, wait.
			timeoutTriggered = true;
		}, delay);

		return function () {
			if (timeoutTriggered) return func.apply(this, arguments);
			// Otherwise, wait.
			funcArgs = arguments;
			funcContext = this;
			funcTriggered = true;
		};
	}


	init() {

		$.extend(DpWpLinkRiver.prototype, {
			posts: {},
			refresh() {
				this.deselect();
				this.visible = this.element.is(':visible');
			},
			show() {
				if (!this.visible) {
					this.deselect();
					this.element.show();
					this.visible = true;
				}
			},
			hide() {
				this.element.hide();
				this.visible = false;
			},
			// Selects a list item and triggers the river-select event.
			select(li, event) {
				let liHeight; let elHeight; let liTop; let
					elTop;

				if (li.hasClass('unselectable') || li == this.selected) return;

				this.deselect();
				this.selected = li.addClass('selected');
				// Make sure the element is visible.
				liHeight = li.outerHeight();
				elHeight = this.element.height();
				liTop = li.position().top;
				elTop = this.element.scrollTop();

				if (liTop < 0) // Make first visible element.
				{ this.element.scrollTop(elTop + liTop); } else if (liTop + liHeight > elHeight) // Make last visible element.
				{ this.element.scrollTop(elTop + liTop - elHeight + liHeight); }

				// Trigger the river-select event.
				this.element.trigger('river-select', [li, event, this]);
			},
			deselect() {
				if (this.selected) this.selected.removeClass('selected');
				this.selected = false;
			},
			prev() {
				if (!this.visible) return;

				let to;
				if (this.selected) {
					to = this.selected.prev('li');
					if (to.length) this.select(to);
				}
			},
			next() {
				if (!this.visible) return;

				const to = this.selected ? this.selected.next('li') : $('li:not(.unselectable):first', this.element);
				if (to.length) this.select(to);
			},
			ajax(callback) {
				const self = this;
				const delay = this.query && this.query.page == 1 ? 0 : this.minRiverAJAXDuration;
				const waiting = this.dpWpLink.inputs.search.parent().find('.spinner').addClass('is-active');
				const response = this.delayedCallback((results, params) => {
					self.process(results, params);
					waiting.removeClass('is-active');
					if (callback) callback(results, params);
				}, delay);
				if (this.query) this.query.ajax(response);
			},
			change(search) {
				if (this.query && this._search == search) return;
				this.posts = {};
				this._search = search;
				this.query = new DpWpLinkQuery(search, this.config);
				this.element.scrollTop(0);
			},
			process(results, params) {
				let list = ''; let alt = true;
				const firstPage = params.page == 1;

				if (!results) {
					if (firstPage) {
						list += `<li class="unselectable no-matches-found"><span class="item-title"><em>${this.config.noMatchesFound}</em></span></li>`;
						this.ul.html(list);
					} else this.ul.append(list);
				} else {
					const addClass = (!this.dpWpLink.isFirstStep) ? 'dpit-special-link' : 'dpit-special-link dpit-special-link--hidden';
					list += this.printPostTypeItem({
						title: this.config.keepPreviousStepUrl,
						permalink: '$keep-prev-step-url',
						info: this.config.variableLink,
						infoLong: this.config.keepPreviousStepUrlLngInfo,
					}, true, addClass);
					list += this.printPostTypeItem({
						title: this.config.keepCurrentUrl,
						permalink: '$keep-current-url',
						info: this.config.variableLink,
						infoLong: this.config.keepCurrentUrlLngInfo,
					}, true, addClass);

					const posts = {};
					const allowedPostTypes = this.config.allowedPostTypesInPagePostURL;
					const loadAllPostTypes = allowedPostTypes.includes('all_post_types');
					$.each(results, function () {
						if (this.info) {
							let type = this.info.toLowerCase();
							const isPost = !isNaN(parseInt(type[0]));
							if (isPost) type = 'post';
							const isAllowed = allowedPostTypes.includes(type);
							if (isAllowed || loadAllPostTypes) {
								if (!posts[type]) posts[type] = [];
								posts[type].push(this);
							}
						}
					});
					Object.keys(posts).forEach((type) => {
						if (this.posts[type]) this.posts[type] = [...posts[type], ...this.posts[type]];
						else this.posts[type] = posts[type];
					});

					allowedPostTypes.forEach((type) => {
						if (type !== 'all_post_types') {
							if (this.posts[type]) {
								this.posts[type].forEach((item) => {
									list += this.printPostTypeItem(item, alt);
									alt = !alt;
								});
							}
						} else {
							Object.keys(this.posts).forEach((type) => {
								if (!allowedPostTypes.includes(type) && !this.config.disabledPostTypes.includes(type)) {
									this.posts[type].forEach((item) => {
										list += this.printPostTypeItem(item, alt);
										alt = !alt;
									});
								}
							});
						}
					});

					this.ul.html(list);
				}
			},
			printPostTypeItem(item, alt, additionalClass = null) {
				let res = '';
				let classes = [];
				if (alt) classes.push('alternate');
				if (additionalClass) classes.push(additionalClass);
				if (!item.title) classes.push('no-title');

				let { permalink } = item;

				if (this.config.siteUrl && !permalink.startsWith(this.config.siteUrl)) {
					// not regenerated permalinks (eg. local host debug with port 3000)
					const urlParts = new URL(this.config.siteUrl);
					urlParts.port = ''; // set port to empty string
					const startUrlNoPort = urlParts.toString().replace(/^\/+|\/+$/g, '');
					if (permalink.startsWith(startUrlNoPort)) {
						permalink = permalink.replace(startUrlNoPort, this.config.siteUrl);
					}
				}

				classes = classes.join(' ');

				res += classes ? `<li class="${classes}">` : '<li>';
				res += `<input type="hidden" class="item-permalink" value="${permalink}" />`;
				res += '<span class="item-title">';
				res += item.title ? item.title : this.config.noTitle;
				res += '</span>';
				res += `<span class="item-info">${item.info}</span>`;
				if (item.infoLong) {
					res += `<div class="item-long-info">${item.infoLong}</div>`;
				}
				res += '</li>';
				return res;
			},
			maybeLoad() {
				const self = this;
				const el = this.element;
				const bottom = el.scrollTop() + el.height();

				if (!this.query.ready() || bottom < this.contentHeight.height() - this.riverBottomThreshold) return;

				setTimeout(() => {
					const newTop = el.scrollTop();
					const newBottom = newTop + el.height();

					if (!self.query.ready() || newBottom < self.contentHeight.height() - this.riverBottomThreshold) return;

					self.waiting.addClass('is-active');
					el.scrollTop(newTop + self.waiting.outerHeight());

					self.ajax(() => {
						self.waiting.removeClass('is-active');
					});
				}, this.timeToTriggerRiver);
			},
		});

		this.refresh();

		$('#dp_wp-link .query-results, #dp_wp-link #dp_link-selector').scroll(this.maybeLoad.bind(this));
		this.element.on('click', 'li', (event) => {
			this.select($(event.target).closest('li'), event);
		});

		this.change('');
	}


}